<template>
  <div class="book-information">
    <div class="intro">
      <img :src="baseUrl + '/storage/' + book.cover" alt="Cover image" />

      <div class="info">
        <h1>{{ book.name }}</h1>
        <span class="author light">Door {{ book.author }}</span>
      </div>
    </div>

    <div class="intro-text">
      <!-- Render Markdown properly -->
      <div class="light" v-html="parsedDescription"></div>

      <a
          target="_blank"
          v-if="book.purchase_link"
          :href="book.purchase_link"
          class="btn"
      >
        Koop dit boek
      </a>
    </div>
  </div>

  <h3>Aanbevelingen</h3>
  <UnownedBooks v-if="book" :exclude="[book.id]" />
</template>

<script>
import { mapActions } from "vuex";
import UnownedBooks from "./UnownedBooks.vue";
import { baseUrl } from "@/http/utl.js";
import { marked } from "marked";

export default {
  name: "BookInformation",
  components: { UnownedBooks },
  data() {
    return {
      book: {},
      baseUrl: baseUrl,
    };
  },
  computed: {
    parsedDescription() {
      return this.book.description ? marked(this.book.description) : "";
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    "$route.params.id": {
      immediate: false,
      handler() {
        this.init();
      },
    },
  },
  methods: {
    ...mapActions("book", ["getBook"]),
    init() {
      let bookId = this.$route.params.id;

      this.getBook(bookId).then((response) => {
        this.book = response;
      });
    },
  },
};
</script>
